import { render, staticRenderFns } from "./SimilarProductsCarousel.vue?vue&type=template&id=bd4de98e&scoped=true"
import script from "./SimilarProductsCarousel.vue?vue&type=script&lang=ts"
export * from "./SimilarProductsCarousel.vue?vue&type=script&lang=ts"
import style0 from "./SimilarProductsCarousel.vue?vue&type=style&index=0&id=bd4de98e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4de98e",
  null
  
)

export default component.exports